/* Bind ordinary crop geometry to the confirmed Shopify variant, not page text. */
(function () {
  'use strict';
  if (window.GIOProductGeometry) return;
  var entries = Object.create(null);
  function error(message) {
    var result = new Error(message || 'Your product options changed. Review the design for the selected size.');
    result.code = 'GIO_OPTIONS_CHANGED';
    return result;
  }
  function section(owner) { return String(owner && owner.dataset && owner.dataset.section || ''); }
  function selected(owner) {
    var node = owner && owner.querySelector('variant-selects [data-selected-variant]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  }
  function skuForScope(owner) {
    var variant = selected(owner);
    if (variant && typeof variant.sku === 'string') return variant.sku;
    var node = owner && owner.querySelector('.variant-sku');
    return node ? node.textContent.trim() : '';
  }
  function sync(owner, variant) {
    var entry = entries[section(owner)];
    if (!entry || entry.owner !== owner) return false;
    entry.ready = false;
    if (!variant || !/^\d{1,20}$/.test(String(variant.id || ''))) { entry.value = null; return true; }
    var result = entry.initialize(variant);
    var ratio = result && result.ratio;
    if (ratio !== null && (!Number.isFinite(ratio) || ratio <= 0)) throw error('This product size could not be prepared. Please choose another option or contact us.');
    var value = { schema: 'gio-product-geometry-v1', productId: entry.productId,
      productHandle: entry.productHandle, variantId: String(variant.id), mode: ratio === null ? 'free' : 'fixed', ratio: ratio };
    if (entry.themeId) value.themeId = entry.themeId;
    entry.value = value; entry.ready = true;
    return true;
  }
  function register(config, owner, initialize) {
    if (!owner || typeof initialize !== 'function' || !/^\d{1,20}$/.test(String(config.productId || ''))) throw error();
    var key = String(config.sectionId || '');
    if (!key || key !== section(owner)) throw error();
    entries[key] = { owner: owner, initialize: initialize, ready: false, value: null,
      productId: String(config.productId), productHandle: String(config.productHandle || ''),
      themeId: /^\d{1,20}$/.test(String(config.themeId || '')) ? String(config.themeId) : '' };
    sync(owner, config.variant);
  }
  function managed(owner) { var entry = entries[section(owner)]; return !!entry && entry.owner === owner; }
  function read(config) {
    var entry = entries[String(config && config.sectionId || '')];
    if (!entry) {
      if (config && config.productGeometryRequired) throw error('The product size tools could not load. Please refresh this page.');
      return null;
    }
    var owner = entry.owner;
    if (!entry.ready || !entry.value || owner.isConnected === false || owner.pendingRequestUrl || owner.variantRequest ||
        owner.gioVariantRequestError || owner.dataset.gioEditorRouteChanging === 'true') throw error('Updating your product size. Please wait, or retry the selected option.');
    var form = owner.querySelector('product-form'), input = form && form.querySelector('input[name="id"]');
    if (!input || String(input.value) !== entry.value.variantId || String(config.productId || '') !== entry.productId) throw error();
    return Object.assign({}, entry.value);
  }
  function assertCurrent(config, expected) {
    var current = read(config);
    if (!current || !expected || expected.schema !== current.schema || expected.mode !== current.mode ||
        String(expected.productId) !== current.productId || String(expected.variantId) !== current.variantId ||
        expected.productHandle !== current.productHandle || String(expected.themeId || '') !== String(current.themeId || '') ||
        expected.ratio !== current.ratio) throw error();
    return current;
  }
  window.GIOProductGeometry = { register: register, sync: sync, read: read, assertCurrent: assertCurrent,
    managed: managed, skuForScope: skuForScope };
}());
